import { render, staticRenderFns } from "./sendMessage.vue?vue&type=template&id=61b390c0&scoped=true"
import script from "./sendMessage.vue?vue&type=script&lang=js"
export * from "./sendMessage.vue?vue&type=script&lang=js"
import style0 from "./sendMessage.vue?vue&type=style&index=0&id=61b390c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b390c0",
  null
  
)

export default component.exports